import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'

export const renderExaminationQuestionSet = ({ renderFooter = null, renderContextMenu = NullAsDefault, handleAction = NullAsDefault }) => (item, index) => {

    return (
        <Translate key={index}>
            {(t) => (
                <div className="py-2 flex flex-col gap-1 rounded-lg custom-item-render custom-render-border relative">
                    <div
                        onClick={() =>{handleAction('questions', item)}}
                        className="font-bold text-color-000 hover:text-primary cursor-pointer">
                        {getTitle(item)}
                    </div>
                    {renderFooter(item)}
                    <div className="absolute right-5 top-5 contextIcon">
                        {renderContextMenu(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}

